<!-- Navbar start -->

<nav class="navbar navbar-expand-lg navbar-dark fixed-top py-0 top-0">
  <div class="container">
    <a class="navbar-brand " href="#"><img class="img-fluid" src="assetses/images/logo.png" alt="Logo"></a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto ms-5">
        <li class="nav-item">
          <a class="nav-link" routerLink="">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/networks">Network</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/hub"> Hub</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/services">Type of services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/cf"> Card Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/package"> View Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/ai"> Additional Features</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
  <!-- Navbar End -->
<!---HERO SECTION---->

<section class="hero">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-10">
        <h1 class="hero-heading" data-aos="fade-up">
          <span class="animated-text">Claim Your Name.</span><br>
          <span class="animated-text delay">Own Your Game.</span>
        </h1>
        <p class="tagline invisible" data-aos="fade-up" data-aos-delay="200">
          A space for forward-thinking young Democrats to connect, create, and drive change.
        </p>
      </div>
    </div>
  </div>
  <div class="hero-icon" style="text-align: center; margin-top: 100px;">
    <svg viewBox="0 0 1100 300" xmlns="http://www.w3.org/2000/svg" width="90%" height="200">
      <rect x="125" y="75" width="850" height="150" rx="75" ry="75" fill="none" stroke="#f9fafb" stroke-width="2" stroke-dasharray="10 10" opacity="0.3"></rect>
      <circle r="8" fill="#f9fafb">
        <animateMotion dur="6s" repeatCount="indefinite" calcMode="linear">
          <mpath href="#borderPath"></mpath>
        </animateMotion>
      </circle>
      <path id="borderPath" d="M200,75 
       h700 
       a75,75 0 0 1 0,150 
       h-700 
       a75,75 0 0 1 0,-150 Z" fill="none" stroke="none"></path>
      <text x="550" y="165" font-size="70" font-weight="600" fill="#f9fafb" text-anchor="middle" opacity="0.2" letter-spacing="6">UMYO HIGHSCHOOL</text>
    </svg>
  </div>
</section>
<!---END HERO SECTION---->


<!---- CARDS SECTION--->
<!-- UMYO Highschool Movement Section -->
<section class="bg-light py-5">
  <div class="container">
    
    <!-- Intro -->
    <div class="row align-items-center mb-5">
      <div class="col-md-6" data-aos="fade-right">
        <img src="assetses/images/Network/1.jpg" alt="UMYO Community Hub" class="img-fluid rounded-4 shadow">
      </div>
      <div class="col-md-6" data-aos="fade-left">
        <h2 class="fw-bold mb-3">UMYO Highschool Community Hub</h2>
        <p class="fw-semibold text-primary">Built for UMYO High School. Powered by Purpose.</p>
        <p>
          UMYO is more than a network — it’s a movement created to empower, support, and uplift UMYO High School students, alumni, families, and community partners.
        </p>
        <p>
          Whether you're launching a business, continuing your education, mentoring the next generation, or looking for ways to give back — 
          <strong>UMYOHighSchool.site</strong> is your platform to grow — personally, professionally, and financially.
        </p>
      </div>
    </div>

    <!-- Scholarships -->
    <div class="row justify-content-center mb-5">
      <div class="col-lg-10">
        <div class="card p-4 border-0 shadow-sm rounded-4 bg-white" data-aos="zoom-in-up">
          <h3 class="fw-bold mb-3">🎓 Weekly Scholarships for UMYO Students & Alumni</h3>
          <p>Your goals matter — and we’re here to invest in your future.</p>
          <p>Each week, UMYO High School Hub awards scholarships to members pursuing:</p>
          <ul class="fw-semibold ps-3">
            <li>Community Colleges</li>
            <li>Trade & Technical Schools</li>
            <li>Business Certifications</li>
            <li>GED & Adult Education Programs</li>
          </ul>
          <p class="mt-3 fw-semibold">We believe in breaking barriers and funding futures — one goal at a time.</p>
        </div>
      </div>
    </div>

    <!-- Contests & Recognition -->
    <div class="row justify-content-center mb-5">
      <div class="col-lg-10">
        <div class="card p-4 border-0 shadow-sm rounded-4 bg-white" data-aos="zoom-in-up">
          <h3 class="fw-bold mb-3">🏆 Contests & Recognition for Excellence</h3>
          <p>Your hard work deserves to be seen.</p>
          <p>Every week, UMYO highlights outstanding students, alumni, and community leaders in areas like academics, leadership, creativity, and service. Winners receive:</p>
          <ul class="fw-semibold ps-3">
            <li>Recognition across <strong>UMYOHighSchool.site</strong></li>
            <li>Sponsored prizes and community support</li>
            <li>Tools and resources to grow their impact</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Gift Cards & Vouchers -->
    <div class="row justify-content-center mb-5">
      <div class="col-lg-10">
        <div class="card p-4 border-0 shadow-sm rounded-4 bg-white" data-aos="zoom-in-up">
          <h3 class="fw-bold mb-3">🛍️ Weekly Gift Cards & Local Business Vouchers</h3>
          <p>Support local. Win with purpose.</p>
          <ul class="fw-semibold ps-3">
            <li>$250 and $500 gift cards</li>
            <li>Redeemable at verified student-, alumni-, or community-owned businesses</li>
          </ul>
          <p class="fw-semibold mt-3">Spend with purpose. Support your own. Win together.</p>
        </div>
      </div>
    </div>

    <!-- Monthly Cash Challenges -->
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card p-4 border-0 shadow-sm rounded-4 bg-white" data-aos="zoom-in-up">
          <h3 class="fw-bold mb-3">💰 Monthly Cash Challenges for Changemakers</h3>
          <p>Real opportunities. Real rewards.</p>
          <p>UMYO invites students, alumni, and local leaders to submit bold ideas and community-driven projects — for a chance to win:</p>
          <ul class="fw-semibold ps-3">
            <li>$5,000 and $10,000 cash awards</li>
            <li>Local and national visibility</li>
            <li>Sponsorships from supporting businesses</li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</section>

<!----END CARDS SECTION--->


<!-- Why UMYO High School Hub -->
<section class="sports bg-light">
  <div class="container py-5 hub">
    <div class="row justify-content-center">
      <div class="col-md-8 text-center">
        <h2 class="fw-bold mb-4" data-aos="fade-up">💡 Why UMYO High School Hub?</h2>
        <p class="lead" data-aos="fade-up">
          Because UMYO deserves more than just tradition — it deserves ownership, opportunity, and support.
        </p>
        <p data-aos="fade-up">
          This is where students, families, educators, alumni, and local businesses connect through:
        </p>
        <ul class="list-unstyled fw-semibold text-white d-inline-block text-start" data-aos="fade-up">
          <li>🎓 Scholarships and mentorship</li>
          <li>🤝 Strategic partnerships</li>
          <li>🚀 Real pathways to education, careers, and success</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row mt-5">

      <!-- Students & Alumni -->
      <div class="col-md-8 mb-4 offset-md-2" data-aos="flip-left">
        <div class="membership-cards h-100 shadow rounded-4 bg-white">
          <div class="card h-100 border-0 p-4">
            <h4 class="card-title mb-3">👥 For Students & Alumni</h4>
            <ul class="list-unstyled ps-3 text-start fw-semibold">
              <li>Build a profile to showcase your goals and achievements</li>
              <li>Access scholarships, grants, and career-building tools</li>
              <li>Promote your business, nonprofit, or creative venture</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Parents, Educators, Supporters -->
      <div class="col-md-8 mb-4 offset-md-2" data-aos="flip-right">
        <div class="membership-cards h-100 shadow rounded-4 bg-white">
          <div class="card h-100 border-0 p-4">
            <h4 class="card-title mb-3">🏛️ For Parents, Educators & Local Supporters</h4>
            <ul class="list-unstyled ps-3 text-start fw-semibold">
              <li>Discover and support emerging student and alumni talent</li>
              <li>Offer mentorship, sponsorship, or internship opportunities</li>
              <li>Connect with others invested in the UMYO mission</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Community & Economic Opportunities -->
      <div class="col-md-8 mb-4 offset-md-2" data-aos="flip-left">
        <div class="membership-cards h-100 shadow rounded-4 bg-white">
          <div class="card h-100 border-0 p-4">
            <h4 class="card-title mb-3">🌍 Community & Economic Opportunities</h4>
            <p class="fw-semibold">UMYO connects its network with:</p>
            <ul class="list-unstyled ps-3 text-start fw-semibold">
              <li>Local business sponsorships</li>
              <li>Development and funding support</li>
              <li>Paid leadership roles in school and community initiatives</li>
              <li>Financial literacy, planning, and capital access</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Business Networking -->
      <div class="col-md-8 mb-4 offset-md-2" data-aos="flip-right">
        <div class="membership-cards h-100 shadow rounded-4 bg-white">
          <div class="card h-100 border-0 p-4">
            <h4 class="card-title mb-3">💼 Business Networking & Digital Tools</h4>
            <p class="fw-semibold">
              In partnership with UMYO’s <em>Wall Street of Technology</em>, we provide:
            </p>
            <ul class="list-unstyled ps-3 text-start fw-semibold">
              <li>A directory of UMYO businesses and services</li>
              <li>Spotlights on community leaders and rising stars</li>
              <li>Real-time messaging and collaboration tools</li>
              <li>A marketplace to buy, sell, and support UMYO-affiliated ventures</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Ambassadors -->
      <div class="col-md-8 mb-4 offset-md-2" data-aos="zoom-in">
        <div class="membership-cards h-100 shadow rounded-4 bg-white text-center">
          <div class="card h-100 border-0 p-4">
            <h4 class="card-title mb-3">🌟 Ambassadors of Impact</h4>
            <p class="text-dark">
              UMYO is led by students, alumni, and community members who champion empowerment,
              excellence, and opportunity — creating a ripple effect of leadership and change.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- Membership Benefits -->
<section class="membership py-5 bg-white">
  <div class="container">
    <div class="row justify-content-center mb-5">
      <div class="col-md-8 text-center">
        <h2 class="fw-bold" data-aos="fade-up">💳 Membership Benefits</h2>
        <p class="lead" data-aos="fade-up">
          Join the UMYO High School Hub community and unlock meaningful opportunities for growth, visibility, and impact.
        </p>
      </div>
    </div>

    <div class="row justify-content-center">

      <!-- Individual Membership -->
      <div class="col-md-5 mb-4" data-aos="fade-right">
        <div class="card h-100 shadow rounded-4 border-0 p-4">
          <div class="card-body">
            <h4 class="card-title mb-3">🎓 Individual Members – $9.99/month</h4>
            <p class="fw-semibold">For students, parents, and alumni who want to grow, connect, and lead.</p>
            <ul class="list-unstyled ps-3 text-start fw-semibold mt-3">
              <li>🎁 Access to giveaways, livestreams, and exclusive events</li>
              <li>🛍️ Custom storefronts to promote your brand or passion</li>
              <li>🎓 Scholarships, career tools, and mentorship</li>
              <li>📣 Branding and marketing support</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Business & Sponsors Membership -->
      <div class="col-md-5 mb-4" data-aos="fade-left">
        <div class="card h-100 shadow rounded-4 border-0 p-4">
          <div class="card-body">
            <h4 class="card-title mb-3">🏢 For Businesses & Sponsors – $49.99/month</h4>
            <p class="fw-semibold">Designed for partners who want to invest in community growth and visibility.</p>
            <ul class="list-unstyled ps-3 text-start fw-semibold mt-3">
              <li>🌐 Premium visibility across <strong>UMYOHighSchool.site</strong></li>
              <li>🤝 Access to student and alumni talent pipelines</li>
              <li>💡 Sponsorship and mentorship opportunities</li>
              <li>📈 Marketing and recruitment aligned with community impact</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!----PRIVACY,CONTROL SECTION--->
<section class="privacy bg-light py-5">
  <div class="container">

    <!-- Private Communities -->
    <div class="row justify-content-center">
      <div class="col-md-10 text-center">
        <h2 class="fw-bold mb-4" data-aos="fade-up">🔐 Private, Secure Digital Communities</h2>
        <p class="lead" data-aos="fade-up">
          Join exclusive, moderated groups designed for authentic collaboration, learning, and support.
        </p>
      </div>

      <div class="col-md-8" data-aos="fade-up">
        <ul class="list-unstyled fw-semibold text-start mt-4 ps-3">
          <li>💬 Real conversations and collaboration spaces</li>
          <li>🎥 Digital tools, video conferencing, and online meetups</li>
          <li>👨‍🎓 Student, alumni, and parent support groups</li>
        </ul>
      </div>
    </div>

    <!-- Divider -->
    <div class="row justify-content-center my-5">
      <div class="col-md-8 text-center">
        <hr class="my-4" style="border-top: 2px dashed #000; width: 70%; margin: 0 auto;">
      </div>
    </div>

    <!-- Join the Movement -->
    <div class="row justify-content-center text-center">
      <div class="col-md-10" data-aos="fade-up">
        <h2 class="fw-bold mb-3">🚀 Join the UMYO Movement</h2>
        <p class="lead mb-4">
          We’re not just building a school community — we’re fueling the future.
        </p>

        <div class="row justify-content-center">
          <div class="col-md-5 mb-3" data-aos="fade-right">
            <div class="card shadow border-0 rounded-4 p-4 h-100">
              <h4>🎓 Students, Alumni & Families</h4>
              <p class="fw-semibold mt-3 mb-1">Join for just <strong>$9.99/month</strong></p>
              <p>Access scholarships, tools, and exclusive opportunities within the UMYO network.</p>
            </div>
          </div>

          <div class="col-md-5 mb-3" data-aos="fade-left">
            <div class="card shadow border-0 rounded-4 p-4 h-100">
              <h4>🏢 Businesses & Sponsors</h4>
              <p class="fw-semibold mt-3 mb-1">Partner with purpose for <strong>$49.99/month</strong></p>
              <p>Support youth programs, gain visibility, and align your brand with community impact.</p>
            </div>
          </div>
        </div>

        <p class="mt-5 fs-5" data-aos="fade-up">
          🚫 No ads. No distractions. No limits.  
          <br><strong>Just ownership, opportunity, and a community rising together.</strong>
        </p>

        <a href="https://umyohighschool.site" class="btn btn-primary btn-lg mt-3 rounded-pill shadow" data-aos="zoom-in">
          👉 Explore UMYOHighSchool.site
        </a>

        <p class="mt-4 text-muted" data-aos="fade-up">
          Fuel the Future of UMYO.
        </p>
      </div>
    </div>
  </div>
</section>
<!----END PRIVACY,CONTROL SECTION--->



<!----READ MORE SECTION--->

<section id="detailsSection" class="overflow-hidden">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-10">
        <h1 class="fw-bold mb-4" data-aos="fade-up">
          🎓 Explore Our Private Digital Communities for the High School Network
        </h1>
        <p class="lead mb-5" data-aos="fade-up">
          Welcome to a suite of secure, purpose-driven platforms built to empower high school students, alumni, families, and local businesses. 
          Whether you’re here to learn, connect, promote, or support — there’s a space just for you.
        </p>
        <p class="fw-semibold fs-5" data-aos="fade-up">Click any platform below to learn more and explore your next opportunity.</p>
      </div>
    </div>
    <div class="row">

      <!-- <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/Eblast.png" alt="Image">
          <h3> UMYO Union Hub Eblast Suite</h3>
          
          <div class="description mt-3" style="display: none" id="sms">
            <span>📬 Union-focused SMS, Email & Video Campaigns</span>
            <p>An advanced communication hub designed for unions and allied businesses to run targeted outreach—like job postings, event blasts, advocacy campaigns, and member announcements.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Automated SMS, email & video messaging</li>
              <li>Real-time engagement tracking</li>
              <li>Customizable union-branded templates and dashboard</li>
            </ul>
            <a (click)="toggleSection('sms', false)"  id="sms_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('sms', true)"  id="sms_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
            Read More
          </a>          
        </div>
      </div> -->

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Talk.png" alt="Image">
          </a>
          <h3>Community Marketplace</h3>
          
          <div class="description mt-3" style="display: none" id="talk">
            <span>🛍 Buy, Sell, and Support Local</span>
            <p>A secure marketplace where students, alumni, and residents can list items, promote services, or discover school-related offers.</p>
            <strong>Key Features:</strong>
            <ul class="list-group">
              <li class="list-group-item">List items like books, uniforms, or art</li>


              <li class="list-group-item">Promote student businesses or services</li>


              <li class="list-group-item">Support local vendors and initiatives</li>
            </ul>
            <a (click)="toggleSection('talk', false)"  id="talk_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a  (click)="toggleSection('talk', true)"  id="talk_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Tweet.png" alt="Image">
          </a>
          <h3>Community Posts</h3>
          
          <div class="description mt-3" style="display: none" id="tweet">
            <span>💬 Speak Up. Stay Informed.</span>
            <p>  Share announcements, motivational messages, or quick updates relevant to your school community.</p>
            <strong>Key Features:</strong>
            <ul class="list-group">
              <li class="list-group-item">Post events or reminders</li>


              <li class="list-group-item">Celebrate student and alumni achievements</li>


              <li class="list-group-item">Follow others in your school network</li>
            </ul>
            <a  (click)="toggleSection('tweet', false)" id="tweet_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('tweet', true)"  id="tweet_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Events.png" alt="Image">
          </a>
          <h3> Events Hub</h3>
          
          <div class="description mt-3" style="display: none" id="event">
            <span>📅 Host or Attend School Events</span>
            <p> A centralized hub for organizing or participating in school-related events, fundraisers, reunions, workshops, and pop-up activities.</p>
            <strong>Key Features:</strong>
            <ul class="list-group">
              <li class="list-group-item">Sell tickets</li>


              <li class="list-group-item">Promote student showcases or performances</li>
              <li class="list-group-item"> 🔗<a href="https://r00events.site/"> Explore Events</a></li>
            </ul>
            <a (click)="toggleSection('event', false)"  id="event_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  (click)="toggleSection('event', true)"  id="event_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

     </div>

     <div class="row">

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/DJ.png" alt="">
          </a>
          <h3>School Radio</h3>
          
          <div class="description mt-3" style="display: none" id="radio">
            <span>📻 Listen. Learn. Lead.</span>
            <p>Online radio for broadcasting school news, stories, or student-run shows. Perfect for media clubs, journalism classes, or alumni spotlights.</p>
            <strong>Key Features:</strong>
            <ul class="list-group ">
              <li class="list-group-item">Play music, news, and interviews</li>


              <li class="list-group-item">Share student perspectives and school culture</li>
              
            </ul>
            <a (click)="toggleSection('radio', false)"  id="radio_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a  (click)="toggleSection('radio', true)"  id="radio_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>


      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Music.png" alt="">
          </a>
          <h3>Youth Music Hub</h3>
          
          <div class="description" style="display: none;" id="music">
            <span>🎶 Stream and Share Student Music</span>
            <p> A music-sharing space for student artists to upload, showcase, and even monetize their original tracks.</p>
            <strong>Key Features:</strong>
            <ul class="list-group ">
              <li class="list-group-item">Upload and stream songs</li>


              <li class="list-group-item">Build a fanbase of peers, alumni, and fans</li>
              <li class="list-group-item"> 🔗 <a href="https://r00music.site/"> Stream Youth Music</a></li> 
            </ul>
            <a (click)="toggleSection('music', false)"  id="music_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="music_more_btn" (click)="toggleSection('music', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Livestreaming.png" alt="">
          </a>
          <h3>Livestream + Podcast</h3>
          
          <div class="description" style="display: none;" id="stream">
            <span>🎙 Go Live with Your Voice</span>
            <p> Host live school podcasts or stream important topics to your peers or alumni. Great for clubs, student gov, or journalism.</p>
            <strong>Key Features:</strong>
            <ul class="list-group ">
              <li class="list-group-item">Audio/video streams</li>


              <li class="list-group-item">Real-time audience interaction</li>
              <li class="list-group-item"> 🔗 <a href="https://r00livestream.site/">  Start Broadcasting</a></li> 
            </ul>
              <a  (click)="toggleSection('stream', false)" id="stream_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>

          </div>
          <a  id="stream_more_btn" (click)="toggleSection('stream', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

     </div>

     <div class="row">

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Estore.png" alt="">
          </a>
          <h3> eStore</h3>
          
          <div class="description" style="display: none;" id="store">
            <span>Sell Your Merchandise. Support Your Brand.</span>
            <p> Create an online store to sell your local merchandise, digital downloads, or services directly to your customers. Secure payment and inventory management tools make the process seamless.</p>
            <strong>Key Features:</strong>
            <ul class="list-group ">
              <li class="list-group-item">Customizable Online Storefront for Atlanta Businesses</li>
              <li class="list-group-item">Inventory Management & Secure Payments</li>
              <li class="list-group-item">Design Your Own Products (Apparel, Gear, etc.)</li>
              <li class="list-group-item">Track Sales & Customer Interactions</li>
            </ul>
            <a (click)="toggleSection('store', false)"  id="store_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="store_more_btn" (click)="toggleSection('store', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Conferencing.png" alt="">
          </a>
          <h3>Conferencing</h3>
          
          <div class="description" style="display: none;" id="room">
            <span>Collaborate and Innovate</span>
            <p> Host secure video conferences for team meetings, community discussions, or neighborhood collaborations. Perfect for <strong>Umyo Highschool organizations and local leaders</strong> to stay connected and organized.</p>
            <strong>Key Features:</strong>
            <ul class="list-group ">
              <li class="list-group-item ">Secure Video/Audio Meetings</li>
              <li class="list-group-item ">Real-Time Chat and File Sharing</li>
              <li class="list-group-item ">Screen Share and Collaboration Tools</li>
              <li class="list-group-item ">Session Recording & Replay Options</li>
            </ul>
            <a (click)="toggleSection('room', false)"  id="room_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="room_more_btn" (click)="toggleSection('room', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Magazine.png" alt="">
          </a>
          <h3>Video Magazine</h3>
          
          <div class="description mt-3" style="display: none" id="magazine">
            <span>📺 School Stories in Motion</span>
            <p> Create a digital magazine full of interviews, performances, and news created by students or alumni media teams.</p>
             🔗<a href="https://umyobiz.com/HairMag1"> View Example</a>
            <a  (click)="toggleSection('magazine', false)" id="magazine_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  (click)="toggleSection('magazine', true)"  id="magazine_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>

     </div>

      <div class="row">

        <div class="col-md-4 p-3 " data-aos="fade-up">
          <div class="platform p-3">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Giveaways.png" alt="">
            <h3>Giveaways & Contests</h3>
            
            <div class="description" style="display: none;" id="prize">
              <span>🎁 Engage and Reward</span>
              <p>Exciting digital giveaways that encourage school spirit, sign-ups, and participation in student-led or alumni events.</p>
              
              <a (click)="toggleSection('prize', false)"  id="prize_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
              Read Less
            </a>
            </div>
            <a  id="prize_more_btn" (click)="toggleSection('prize', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
              Read More
            </a>          
          </div>
        </div>

        <div class="col-md-4 p-3 " data-aos="fade-up">
          <div class="platform p-3">
            <img class="img-fluid lozad" src="assetses/images/PlatformsType/Coupons.png" alt="">
            <h3>Student Coupon Book</h3>
            
            <div class="description mt-3" style="display: none" id="book">
              <span>💸 Promote Local & Student Businesses</span>
              <p> A digital coupon platform for nearby businesses that support the school and students running their own services.</p>
              
              <a (click)="toggleSection('book', false)"  id="book_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
              Read Less
            </a>
            </div>
            <a (click)="toggleSection('book', true)"  id="book_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
              Read More
            </a>          
          </div>
        </div>


      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/News.png" alt="">
          </a>
          <h3>School News Platform</h3>
          
          <div class="description" style="display: none;" id="news">
            <span>🗞 News by Us, for Us</span>
            <p> An automated and curated news hub featuring school news, student highlights, sports, and entertainment updates.</p>
            🔗 <a href="https://r00news.site/">Read Now</a> 
            <a  (click)="toggleSection('news', false)" id="news_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="news_more_btn" (click)="toggleSection('news', true)"  class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#" target="_blank">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/Video.png" alt="">
          </a>
          <h3>Video Hub</h3>
          
          <div class="description" style="display: none;" id="talent">
            <span>🎥 Your Digital Stage</span>
            <p> Post student performances, class projects, or messages from school leaders in a safe, curated platform.</p>
            <strong>Key Features:</strong>
            <ul class="list-group ">
              <li class="list-group-item">Create channels for classes or clubs</li>


              <li class="list-group-item">Moderate content and comments</li>


              <li class="list-group-item">Track views and engagement</li>
            </ul>
            <p> 📧 Start at: <a href="mailto:video@umyovideo.com">video@umyovideo.com</a></p>
            <a (click)="toggleSection('talent', false)"  id="talent_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="talent_more_btn" (click)="toggleSection('talent', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3" data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/AI.png" alt="Image">
          <h3> AI Chat</h3>

          <div class="description" style="display: none;" id="chat">
            <span>Your Secure AI Assistant for the Community and Beyond.</span>
            <p>Umyo Highschool Community Hub ChatGPT is a custom AI solution built for secure communication, daily updates, local news, and real-time social support—protected by advanced encryption.</p>
            <strong>AI Capabilities Designed for You:</strong>
            <ul class="list-group ">
              <li class="list-group-item ">Secure, Encrypted Access for Trusted Conversations</li>
              <li class="list-group-item ">Instant Language Translation & Real-Time Updates</li>
              <li class="list-group-item ">Task Automation for Everyday Activities</li>
              <li class="list-group-item ">Accurate Q&A for News, Tips, & Community Info</li>
              <li class="list-group-item ">Optimized for Low-Bandwidth & Offline Scenarios</li>
            </ul>
            <span>Stay informed. Share openly. Connect safely—with Umyo Highschool Community Hub.</span>
            <a (click)="toggleSection('chat', false)" id="chat_less_btn" class="btn btn-hover-purple border-dark gap-2 mt-2">Read Less</a>
          </div>
          <a (click)="toggleSection('chat', true)" id="chat_more_btn" class="btn btn-hover-purple border-dark gap-2 mt-2">Read More</a>
        </div>
      </div>
      <!-- DATING -->
      <div class="col-md-4 p-3" data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/Dating.png" alt="">
          <h3>Dating</h3>

          <div class="description" style="display: none;" id="game">
            <span>Game. Compete. Connect — Securely.</span>
            <p>Enjoy a curated collection of competitive online games—accessible securely through Umyo Highschool Community Hub Games. Whether for relaxation or bonding, play without borders or risks.</p>
            <strong>Online Gaming Highlights:</strong>
            <ul class="list-group list-group-flush">
              <li class="list-group-item bg-transparent text-white">Low-Latency Servers for Seamless Play</li>
              <li class="list-group-item bg-transparent text-white">Access Region-Locked Games Anywhere</li>
              <li class="list-group-item bg-transparent text-white">Multiplayer Matchmaking with Encrypted Privacy</li>
              <li class="list-group-item bg-transparent text-white">Strategy-Based Team Titles</li>
              <li class="list-group-item bg-transparent text-white">Weekly Tournaments & Leaderboards</li>
            </ul>
            <strong>Play smart. Play secure. With Umyo Highschool Community Hub.</strong>
            <a (click)="toggleSection('game', false)" id="game_less_btn" class="btn btn-hover-purple border-dark gap-2 mt-2">Read Less</a>
          </div>
          <a id="game_more_btn" (click)="toggleSection('game', true)" class="btn btn-hover-purple border-dark gap-2 mt-2">Read More</a>
        </div>
      </div>
    </div>
    <div class="row">

      

      <!-- FANS -->
      <div class="col-md-4 p-3" data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/Fans.png" alt="">
          <h3>Fans</h3>

          <div class="description mt-3" style="display: none" id="fans">
            <span>Create. Connect. Monetize.</span>
            <p>UMYO Highschool Fans is an exclusive content-sharing platform that allows creators to earn money by sharing premium content with their fans. Whether you’re an artist, influencer, or content creator, UMYO Highschool Fans helps you monetize your work through subscriptions, exclusive content, and direct fan interactions.</p>
            <strong>Key Features:</strong>
            <ul class="list-group">
              <li class="list-group-item">Monetize Content Through Subscriptions</li>
              <li class="list-group-item">Create Exclusive Content for Your Fans</li>
              <li class="list-group-item">Connect with Fans on a Deeper, More Personal Level</li>
              <li class="list-group-item">Offer Behind-the-Scenes Access, Early Releases, and More</li>
            </ul>
            <a (click)="toggleSection('fans', false)" id="fans_less_btn" class="btn btn-hover-purple border-dark gap-2 mt-2">Read Less</a>
          </div>
          <a id="fans_more_btn" (click)="toggleSection('fans', true)" class="btn btn-hover-purple border-dark gap-2 mt-2">Read More</a>
        </div>
      </div>


      <!-- MEN NO PAUSE -->
      <div class="col-md-4 p-3" data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/Men_No_Pause.png" alt="">
          <h3>Men United – Weekly Talks</h3>

          <div class="description" style="display: none;" id="men">
            <span>🛡 A Safe Space for Young Men</span>
            <p> Wednesdays @ 7:30 PM (Live Virtual Room)<br>
             Guided by mentors, alumni, and community leaders — a weekly space to talk real, learn, and grow.</p>

            <p> 🔗 <a href="https://live.umyoconvo.site/rooms/menunited/join">Join Room</a> </p>
            <button (click)="toggleSection('men', false)" id="men_less_btn" class="btn btn-hover-purple border-dark gap-2 mt-2">Read Less</button>
          </div>
          <a id="men_more_btn" (click)="toggleSection('men', true)" class="btn btn-hover-purple border-dark gap-2 mt-2">Read More</a>
        </div>
      </div>

      <!-- VPN -->
      <div class="col-md-4 p-3" data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/images/PlatformsType/VPN.png" alt="">
          <h3>Private VPN for Students</h3>

          <div class="description" style="display: none;" id="vpn">
            <span><strong>🔐 Browse Safe at School and Home</strong></span>
            <p> Protect student and family privacy with military-grade encrypted VPN access.</p>

            <button (click)="toggleSection('vpn', false)" id="vpn_less_btn" class="btn btn-hover-purple border-dark gap-2 mt-2">Read Less</button>
          </div>
          <a id="vpn_more_btn" (click)="toggleSection('vpn', true)" class="btn btn-hover-purple border-dark gap-2 mt-2">Read More</a>
        </div>
      </div>

    </div>

     <div class="row justify-content-center">
       <div class="col-md-10 mt-5">
          <div class="text-center ">
            <h1 class="mt-5 text-white aos-init aos-animate" data-aos="fade-up">🌟 Want to Join or Learn More?</h1>
           
            <p class="mt-4 fs-5 text-white aos-init aos-animate" data-aos="fade-up">
              These platforms are designed to uplift your school network — from current students and alumni to teachers, local businesses, and supporters.
            </p>
            
          </div>
        </div>      
     </div>

  </div>
</section>
<!----END READ MORE SECTION--->